import * as React from 'react';
import DocumentMeta from 'react-document-meta';
import { RouteComponentProps, withRouter } from 'react-router';
import { Subtract } from 'utility-types';
import { InjectedApiProps, withApi } from './Api';

export type Pages = {
    page?: IPageDto;
    loadingId: string;
    activeId: string;
};

const initState: Pages = {
    loadingId: '',
    activeId: ''
}

const PagesReactContext = React.createContext<Pages>(initState);

export type PagesProdiverProps = {};
type Props =
    RouteComponentProps<any> &
    PagesProdiverProps &
    
    InjectedApiProps;

class PagesProvider extends React.Component<Props, Pages> {
    private count: number = 0;
    constructor(props: Props) {
        super(props);

        const { apiCtx: { app } } = props;
        this.state = {
            page: app && app.Page,
            loadingId: '',
            activeId: app && app.Page && app.Page.UID || ''
        };
    }

    componentDidMount() {
        const { location: { pathname } } = this.props;
        const { page } = this.state;
        if (!page) {
            this._pathChanged(pathname);
        }
    }

    componentDidUpdate(prevProps: Props, prevState: Pages) {
        const { location: { pathname: prevPathName } } = prevProps;
        const { location: { pathname } } = this.props;
        // const { active } = this.state;

        if (prevPathName !== pathname) {
            this._pathChanged(pathname);
        }

    }

    public render() {
        return (
            <PagesReactContext.Provider value={this.state}>
                {this.state.page &&
                    <DocumentMeta
                        title={this.state.page.PageTitle || ''}
                        description={this.state.page.Description || ''}
                    />
                }
                {this.props.children}
            </PagesReactContext.Provider>
        );
    }

    private _get(pathname: string, id: string) {
        const { apiCtx: { get } } = this.props;
        
        get(pathname)
            .then((page) => {
                if (id !== this.state.loadingId) { return }

                this.setState(
                    () => ({
                        activeId: id,
                        loadingId: '',
                        page
                    })
                )
            })
            .catch(reason => {
                // tslint:disable-next-line: no-console
                console.error(reason);
            });
    }

    private _pathChanged(pathname: string) {
        const id = pathname + (this.count++);
        this.setState(
            () => ({ loadingId: id }),
            () => this._get(pathname, id)
        );
    }

    // private _checkLinks() {
    //     const links = document.body.querySelectorAll('a');
    //     links.forEach(link => {
    //         if (link.dataset.cursor) { return; }
    //         link.dataset.cursor = "true";
    //         link.addEventListener("mouseenter", () => this.props.cursor.setType('link'))
    //         link.addEventListener("mouseleave", () => this.props.cursor.setType('default'))
    //     })
    // }

}

export type InjectedPagesProps = { pagesCtx: Pages };
export const withPages =
    <OriginalProps extends InjectedPagesProps>(
        Component: React.ComponentType<OriginalProps>
    ): React.FunctionComponent<Subtract<OriginalProps, InjectedPagesProps>> => {

        return (props: Subtract<OriginalProps, InjectedPagesProps>) => {
            return (
                <PagesReactContext.Consumer>
                    {(pagesCtx) => <Component {...{ ...(props as object), pagesCtx } as OriginalProps} />}
                </PagesReactContext.Consumer>
            );
        };
    };

export default withRouter(withApi(PagesProvider));


// WEBPACK FOOTER //
// ./src/_context/Pages.tsx